import classNames from 'classnames'
import {
  ForwardedRef,
  forwardRef,
  KeyboardEvent,
  useEffect,
  useRef,
} from 'react'
import BaseCheckbox from 'shared/components/base/form/base-checkbox'
import BaseSelect from 'shared/components/base/form/base-select'
import Input from 'shared/components/elements/input'

import { CategoryType } from './types/category-type'

type PropType = {
  hasSelectComponent: boolean
  newCategory: CategoryType & { id: string }
  onNameChange: (id: string, name: string) => void
  onRequestedQuantitySelect: (id: string, selectedValue: string) => void
  onRemove: (id: string) => void
}
const NewProductRow = forwardRef(
  (props: PropType, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      onNameChange,
      newCategory,
      onRequestedQuantitySelect,
      onRemove,
      hasSelectComponent,
    } = props
    const { id, selectedValue, label } = newCategory
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
      inputRef?.current?.focus?.()
    }, [])

    const requestQuantity = [
      { label: 'مقدار درخواستی', value: '', key: '0' },
      { label: 'یک ظرفیت', value: 'eq', key: 'eq' },
      { label: 'کمتر از یک ظرفیت', value: 'lt', key: 'lt' },
      { label: 'بیشتر از یک ظرفیت', value: 'gt', key: 'gt' },
    ]

    function handleEnterPress(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        inputRef?.current?.blur()
      }
    }

    return (
      <div className="grid grid-cols-11 gap-4 pl-2" ref={ref}>
        <div
          className={
            'flex border-dashed border-1 rounded-lg border-[#D8D8D8] col-span-7 items-center py-2 px-4'
          }
        >
          <BaseCheckbox
            label={
              <Input
                onKeyDown={handleEnterPress}
                ref={inputRef}
                className="border-none outline-none w-full"
                onChange={(event) => {
                  if (event.target.value.includes('*')) {
                    event.target.value = event.target.value.replace('*', '')
                    document.getElementById('search-operator')?.focus()
                    return
                  }
                  onNameChange(id, event.target.value)
                }}
                value={label}
                placeholder="نام کالا را وارد کنید..."
              />
            }
            checked={true}
            onChange={() => onRemove(id)}
          />
        </div>
        <div className="col-span-4">
          {hasSelectComponent && (
            <BaseSelect<string>
              setInputClassName={() =>
                classNames('pt-1 border-dashed border-gray-medium')
              }
              onSelect={(value) => onRequestedQuantitySelect(id, value)}
              value={selectedValue}
              defaultValue={''}
              options={requestQuantity}
            />
          )}
        </div>
      </div>
    )
  }
)
NewProductRow.displayName = 'NewProductRow'

export default NewProductRow
